module.exports = __webpack_public_path__ + "img/self-assessment.8f7a6030.svg";